module.exports = __webpack_public_path__ + "img/p2.d539fcb2.png";